import en from './en.onboarding.json';

export const onboarding = {
  en,
};
